// 📁 src/services/apiService.js
 
import unifiedAuthManager from "./unifiedAuthManager";
import { getJToken, getUserEmail, getTenantId, getUserId } from "../services/authService";
import { triggerSessionTimeout } from "../common/sessionTimeoutModal";
 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
/**
* Generic API call service using fetch.
* This version correctly handles GET, POST, PUT, DELETE, and PATCH methods.
* 
* @param {Object} config - API call configuration
* @param {string} config.method - HTTP method
* @param {string} config.endpoint - API endpoint (must start with a '/')
* @param {Object} config.params - Request parameters/body
* @param {boolean} config.isFile - Whether request contains file uploads
* @returns {Promise} API response data
*/
export async function callApi({
  method,
  endpoint,
  params = {},
  isFile = false,
  signal = null,
  broadBean=false
}) {
  var BASE_URL = '';
  
  if(broadBean==true){
    BASE_URL=process.env.REACT_APP_API_BASE_URL
  }else{
    BASE_URL=process.env.REACT_APP_API_BASE_URL;
  }  
  const userDetails = unifiedAuthManager.getUnifiedUser();
  const token = getJToken();
  // --- 1. Set up headers ---
  const headers = new Headers();
  // Do not set Content-Type for FormData, the browser does it automatically with the correct boundary.
  if (!isFile) {
    headers.append("Content-Type", "application/json");
  }
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }
  // Prefer explicit getters; fallback to unified user if present
  const email = getUserEmail() || userDetails?.email;
  const tenantId =  getTenantId() || userDetails?.tenant_id;
  const userId =  getUserId() || userDetails?.id;
  if (email) headers.append("x-user-email", email);
  if (tenantId) headers.append("x-tenant-id", `${tenantId}`);
  if (userId) headers.append("x-user-id", `${userId}`);
  headers.append("request-id", Math.floor(Math.random() * 1000).toString());
  if(process.env.REACT_APP_SUBSCRIPTION_KEY != null || process.env.REACT_APP_SUBSCRIPTION_KEY != undefined || process.env.REACT_APP_SUBSCRIPTION_KEY != ''){
    headers.append("Ocp-Apim-Subscription-Key", process.env.REACT_APP_SUBSCRIPTION_KEY );
  }

  // --- 2. Initialize options and URL ---
  const options = {
    method: method.toUpperCase(),
    headers,
    credentials: 'include',
    signal: signal || undefined  
  };
  let url = `${BASE_URL}${endpoint}`;
 console.log(url)
  // --- 3. THE FIX: Unified logic for all methods ---
 
  // For GET or DELETE, params become URL query string
  if (["GET", "DELETE"].includes(options.method) && Object.keys(params).length > 0) {
    url += `?${new URLSearchParams(params).toString()}`;
  } 
  // For POST, PUT, PATCH, params become the request body
  else if (["POST", "PUT", "PATCH"].includes(options.method)) {
    if (isFile) {
      const formData = new FormData();
      Object.entries(params).forEach(([key, value]) => {
        if (key === 'files' && Array.isArray(value)) {
          value.forEach(file => formData.append('files', file));
        } else {
          // If value is an object (not a File), stringify it before appending
          if (typeof value === 'object' && value !== null && !(value instanceof File)) {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }
      });
      options.body = formData;
    } else {
      options.body = JSON.stringify(params);
    }
  }
 
  // --- 4. Make the single, final fetch call ---
  try {
    console.log('API Call (fetch):', { method: options.method, url: url, options: options });
    const response = await fetch(url, options);
    // *** SESSION TIMEOUT CHECK ***
    if (response.status === 401) {
      console.log('Session timeout detected (403), triggering modal');
      triggerSessionTimeout();
      
      // Still throw the error for existing error handling
      const errorData = await response.json().catch(() => ({ message: 'Session expired' }));
      throw { ...errorData, status: response.status };
    }

    // Handle HTTP errors
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw { ...errorData, status: response.status };
    }
 
    // Handle successful responses
    if (response.status === 204) {
      return null; // Handle No Content responses
    }
    const data = await response.json();
    console.log('API Response (fetch):', data);
    return data;
 
  } catch (err) {
    console.log("API Error (fetch):", err);
    throw err;
  }
}